// Светофор (решение Анны 03.11.2026): зелёный — норма, жёлтый — внимание, красный — срочно,
// серый — нет данных, без цвета — объём работы. Чистая логика для TrafficBoard.vue.

export const LIGHT_RANK = { neutral: -1, green: 0, gray: 1, yellow: 2, red: 3 }
export const LIGHT_LABELS = { green: 'Норма', yellow: 'Внимание', red: 'Срочно', gray: 'Нет данных', neutral: '' }

// Сначала то, что горит: красные, жёлтые, серые; затем зелёные; счётчики без цвета — в конце.
export function sortTiles(tiles = []) {
  return tiles
    .map((tile, index) => ({ tile, index }))
    .sort((a, b) => {
      const ra = LIGHT_RANK[a.tile.state] ?? 0
      const rb = LIGHT_RANK[b.tile.state] ?? 0
      if (ra === -1 || rb === -1) return rb === -1 && ra !== -1 ? -1 : ra === -1 && rb !== -1 ? 1 : a.index - b.index
      return rb - ra || a.index - b.index
    })
    .map(({ tile }) => tile)
}

// Всё зелёное — окно свёрнуто, туда можно не смотреть.
export function collapsedByDefault(board) {
  return !board || board.state === 'green'
}

export function counts(tiles = []) {
  const result = { red: 0, yellow: 0, gray: 0, green: 0 }
  for (const tile of tiles) if (tile.state in result) result[tile.state] += 1
  return result
}

export function boardSummary(board) {
  if (!board) return ''
  const c = counts(board.tiles)
  const parts = []
  if (c.red) parts.push(`срочно — ${c.red}`)
  if (c.yellow) parts.push(`внимание — ${c.yellow}`)
  if (c.gray) parts.push(`нет данных — ${c.gray}`)
  return parts.length ? parts.join(', ') : `все ${c.green} в норме`
}

export function canOpen(tile) {
  return Boolean(tile && tile.group && Number(tile.value) > 0)
}
